import {
    Plus,
    Dashboard,
    Code,
    ArchivalDocuments,
    Icd10,
    Npi,
    Cde,
    AdvancedPdfSearch,
    Analytics,
    Domain,
    ReferenceSources,
    RxNorm,
    Users,
    DataSources,
    Fhir,
    Rdd,
    MetaIQ,
    Database,
    Upload,
    DataScience,
    Reports,
    Tools,
} from "icons";

import {
    DataManagement,
    DataIngestion,
    DataConsumption,
    Settings,
} from "src/components/index";

export const SIDEBAR_LINKS_MANAGEMENT = [
    // {
    //   icon: Plus,
    //   label: "Data Transparency Dashboard",
    //   to: "/management/data-transparency-dashboard",
    // },
    {
        icon: Users,
        label: "People",
        to: "/management/people",
        "data-cy": "people-link",
    },
    {
        icon: Domain,
        label: "Domains",
        to: "/management/domains",
        "data-cy": "domains-link",
    },
    {
        icon: Cde,
        label: "CDE Definitions",
        to: "/management/cde-definitions",
        "data-cy": "cde-definitions-link",
    },
    {
        icon: DataSources,
        label: "Data Sources",
        to: "/management/data-sources",
        "data-cy": "data-sources-link",
    },
    {
        icon: Plus,
        label: "Business Glossary",
        to: "/management/business-glossary",
        "data-cy": "business-glossary-link",
    },
    {
        icon: Plus,
        label: "Reference Sources",
        to: "/management/reference-sources",
    },
    {
        icon: ReferenceSources,
        label: "Reference Data",
        to: "/management/reference-data/",
        "data-cy": "reference-data-link",
        items: [
            {
                label: "Reference Sources",
                to: "/management/reference-data/reference-sources",
                icon: Plus,
                "data-cy": "reference-sources-link",
            },
            {
                label: "ICD 10",
                to: "/management/reference-data/icd",
                icon: Icd10,
                "data-cy": "icd-link",
            },
            {
                label: "RxNorm",
                to: "/management/reference-data/rxnorm",
                icon: RxNorm,
                "data-cy": "rxnorm-link",
            },
            {
                label: "NPI",
                to: "/management/reference-data/npi-registry",
                icon: Npi,
                "data-cy": "npi-registry-link",
            },
            {
                label: "Meta IQ",
                to: "/management/reference-data/meta-iq",
                icon: MetaIQ,
                "data-cy": "meta-iq-link",
            },
            {
                label: "FHIR Converter",
                to: "/management/reference-data/fhir-converter",
                icon: Fhir,
                "data-cy": "fhir-converter-link",
            },
            {
                label: "FHIR Information Guide",
                to: "/management/reference-data/fhir-information-guide",
                icon: Fhir,
                "data-cy": "fhir-information-guide-link",
            },
        ],
    },
    // {
    //   icon: Plus,
    //   label: "Business Glossary",
    //   to: "/management/business-glossary",
    // },
    // {
    //   icon: Plus,
    //   label: "Rules",
    //   to: "/management/rules",
    // },
];

export const SIDEBAR_LINKS_SETTINGS = [
    {
        icon: Plus,
        label: "Upload Logo",
        to: "/settings/logo",
    },
    {
        icon: Plus,
        label: "Theme",
        to: "/settings/theme",
    },
];

export const SIDEBAR_FOOTER_LINKS = [
    // {
    //   icon: Plus,
    //   label: "Help Center",
    //   to: "/help-center",
    // },
];

export const SIDEBAR_LINKS_INGESTION = [
    {
        icon: DataSources,
        label: "Connections",
        to: "/ingestion/source-databases",
        "data-cy": "connections-link",
    },
    // {
    //   icon: Plus,
    //   label: "Delimited Data (CSV)",
    //   to: "/ingestion/delimited-data",
    // },
    // {
    //   icon: Plus,
    //   label: "SFTP Accounts",
    //   to: "/ingestion/sftp-accounts",
    // },
    {
        icon: ArchivalDocuments,
        label: "Archival Documents",
        to: "/ingestion/archival-reports",
        "data-cy": "archival-documents-link",
    },
    {
        icon: AdvancedPdfSearch,
        label: "Advanced PDF Search",
        to: "/ingestion/nested-pdf-search",
        "data-cy": "advanced-pdf-search-link",
    },
    {
        icon: Upload,
        label: "Upload From Local",
        to: "/ingestion/upload-from-local",
        "data-cy": "upload-from-local-link",
    },
];

export const SIDEBAR_LINKS_CONSUMPTION = [
    {
        label: "Datasets",
        to: "/consumption/datasets",
        icon: Database,
        "data-cy": "datasets-link",
    },
    {
        label: "Reporting",
        showIcon: false,
        to: "/consumption/reporting/dashboards",
        icon: Reports,
        "data-cy": "reporting-link",
        items: [
            {
                showIcon: false,
                label: "Data Explorer",
                to: "/consumption/reporting/data-explorer",
                "data-cy": "data-explorer-link",
            },
            {
                icon: Dashboard,
                label: "Dashboards",
                to: "/consumption/reporting/dashboards",
                "data-cy": "dashboards-link",
            },
            {
                label: "Credentialing Edit UI",
                to: "/consumption/reporting/credentialing-dashboard",
                "data-cy": "credentialing-dashboard-link",
            },
            {
                label: "Multi-Source Exception Profiling Report",
                to: "/consumption/reporting/multi-source-exception-profiling",
                "data-cy": "multi-source-exception-profiling-report-link",
            },
            {
                label: "Provider Manager",
                to: "/consumption/reporting/provider-manager",
                "data-cy": "provider-manager-link",
            },
            {
                label: "Trust Rules",
                to: "/consumption/reporting/trust-rules",
                items: [
                    {
                        label: "Record Details",
                        to: "/consumption/reporting/trust-rules/record-details",
                        "data-cy": "record-details-link",
                    },
                    {
                        label: "Business Rules",
                        to: "/consumption/reporting/trust-rules/business-rules",
                        "data-cy": "business-rules-link",
                    },
                ],
            },
            {
                label: "Metadata Report",
                to: "/consumption/reporting/metadata-report",
            },
            {
                label: "CDE Review Report",
                to: "/consumption/reporting/cde-review-report",
            },
        ],
    },
    {
        label: "Data Science",
        to: "/consumption/data-science/predictive-analysis/rdd",
        showIcon: false,
        icon: DataScience,
        "data-cy": "data-science-link",
        items: [
            {
                label: "Predictive Analysis",
                icon: Plus,
                "data-cy": "predictive-analysis-link",
                items: [
                    {
                        icon: Rdd,
                        label: "Renal Disease Detection",
                        to: "/consumption/data-science/predictive-analysis/rdd",
                        "data-cy": "rdd-link",
                    },
                ],
            },
            {
                label: "Quality Analysis",
                icon: Plus,
                "data-cy": "quality-analysis-link",
                items: [
                    {
                        label: "Approachable AI",
                        to: "/consumption/data-science/quality-analysis/approachable-ai",
                        icon: Analytics,
                        "data-cy": "approachable-ai-link",
                    },
                    {
                        icon: Analytics,
                        label: "Data Quality Analysis",
                        to: "/consumption/data-science/quality-analysis/data-qa-analysis",
                        "data-cy": "data-quality-analysis-link",
                    },
                ],
            },
        ],
    },
    {
        label: "Tools",
        to: "/consumption/tools/sql-editor",
        showIcon: false,
        icon: Tools,
        "data-cy": "tools-link",
        items: [
            {
                icon: Code,
                label: "SQL Editor",
                to: "/consumption/tools/sql-editor",
                "data-cy": "sql-editor-link",
            },
        ],
    },
];

// TODO: Delte if not required
// export const PRIVATE_ROUTES = [
//   {
//     path: "/management",
//     component: DataManagement,
//     isExact: false,
//   },

//   {
//     path: "/ingestion",
//     component: DataIngestion,
//     isExact: false,
//   },

//   {
//     path: "/consumption",
//     component: DataConsumption,
//     isExact: true,
//   },
//   {
//     path: "/settings",
//     component: Settings,
//     isExact: true,
//   },
// ];
